import { render, staticRenderFns } from "./BroilerDashboardDetail.vue?vue&type=template&id=c63397dc&"
import script from "./BroilerDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./BroilerDashboardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BroilerDashboardDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports